interface Props {
  title: string;
  meta?: string;
}

function SectionHeader({ title, meta }: Props) {
  return (
    <div className="flex items-baseline justify-between gap-4 mb-4 sm:mb-5">
      <h2 className="font-display" style={{ fontSize: "var(--display-2)" }}>
        {title}
      </h2>
      {meta && (
        <span className="text-[12px] tabular-nums text-fg-subtle">
          {meta}
        </span>
      )}
    </div>
  );
}

export default SectionHeader;
